"use client";

import { useRouter } from 'next/navigation';
import React from 'react';

const BackButton = ({ link }) => {
	const router = useRouter();

	const handleNavigation = () => {
		if (link) {
			router.push(link);
		} else if (window.history.length > 1) {
			router.back();
		} else {
			router.push('/search');
		}
	};

	return (
		<div
			onClick={handleNavigation}
			className="w-max flex items-center gap-2 cursor-pointer"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="20"
				height="15"
				viewBox="0 0 20 15"
				fill="none"
			>
				<path
					d="M19 8.4C19.4971 8.4 19.9 7.99706 19.9 7.5C19.9 7.00294 19.4971 6.6 19 6.6V8.4ZM0.363604 6.8636C0.0121326 7.21508 0.0121326 7.78492 0.363604 8.1364L6.09117 13.864C6.44264 14.2154 7.01249 14.2154 7.36396 13.864C7.71543 13.5125 7.71543 12.9426 7.36396 12.5912L2.27279 7.5L7.36396 2.40883C7.71543 2.05736 7.71543 1.48751 7.36396 1.13604C7.01249 0.784567 6.44264 0.784567 6.09117 1.13604L0.363604 6.8636ZM19 6.6L1 6.6V8.4L19 8.4V6.6Z"
					fill="#354EF0"
				/>
			</svg>
			<div className="text-[14px] font-normal font-poppins text-[#8E8E8E]">
				Back
			</div>
		</div>
	);
}

export default BackButton